const pages = {
  about: {
    title: 'Sobre o Reserve Connect',
    description: 'Conectando viajantes às melhores experiências na Serra Catarinense.',
  },
  contact: {
    title: 'Fale Conosco',
    description: 'Entre em contato com nossa equipe.',
  },
  groups: {
    title: 'Grupos e Agências',
    description: 'Soluções especiais para grupos e agências de viagem.',
    formUnavailable: 'Formulário temporariamente indisponível. Entre em contato pelo WhatsApp.',
  },
  cityGuide: {
    title: 'O que fazer em Urubici SC',
    subtitle: 'Pontos Turísticos, Cachoeiras e Aventuras',
  },
  terms: { title: 'Termos de Uso' },
  privacy: { title: 'Política de Privacidade' },
  cookies: { title: 'Política de Cookies' },
  cancellation: { title: 'Política de Cancelamento e Reembolso' },
  restaurants: { title: 'Restaurantes em Urubici' },
  experiences: { title: 'Experiências em Urubici' },
  events: { title: 'Eventos em Urubici' },
  notFound: {
    title: 'Página não encontrada',
    description: 'A página que você procura não existe ou foi movida.',
    backHome: 'Voltar para o início',
  },
  city: {
    heroTitle: 'Hospedagem em {{cityName}} com disponibilidade em tempo real',
    heroDescription: 'Reserve direto com hotéis locais, com atualização automática de disponibilidade.',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    guests: 'Hóspedes',
    guest_1: '1 hóspede',
    guest_2: '2 hóspedes',
    guest_3: '3 hóspedes',
    guest_4: '4 hóspedes',
    guest_5: '5 hóspedes',
    guest_6: '6+ hóspedes',
    searchAvailability: 'Buscar disponibilidade',
    directBooking: 'Sem intermediários. Confirmação direta com o hotel.',
    secureBooking: 'Reserva segura',
    realAvailability: 'Disponibilidade real',
    verifiedHotels: 'Hotéis verificados',
  },
  ondeIr: {
    heroTitle: 'Descubra o que faz Urubici ser inesquecível',
    heroDescription: 'Natureza exuberante, frio de verdade e experiências que pedem a hospedagem certa.',
    seeNearbyLodging: 'Ver hospedagens próximas aos atrativos',
    exploreRoutes: 'Explorar roteiros',
    attractionsTitle: 'Atrativos que definem Urubici',
    attractionsDescription: 'Escolha a experiência que combina com você e encontre a hospedagem ideal por perto.',
    morroDaIgreja: 'Morro da Igreja',
    morroDaIgrejaDesc: 'Um dos pontos mais altos do Sul do Brasil, com vista impressionante e frio intenso no inverno.',
    seeLodgingNearby: 'Ver hospedagens próximas',
    serraCorvoBranco: 'Serra do Corvo Branco',
    serraCorvoBrancoDesc: 'Estrada cênica com paredões gigantes e parada obrigatória para motociclistas.',
    lodgingForMotorcyclists: 'Hospedagens ideais para motociclistas',
    cachoeirasSerra: 'Cachoeiras da Serra',
    cachoeirasSerraDesc: 'Natureza preservada e trilhas para quem busca tranquilidade e contato com o verde.',
    searchNatureLodging: 'Buscar hospedagens na natureza',
    centroHistorico: 'Centro Histórico',
    centroHistoricoDesc: 'Restaurantes, cafés e fácil acesso aos principais pontos da cidade.',
    seeDowntownLodging: 'Ver hospedagens no centro',
    temporadaInverno: 'Temporada de Inverno',
    temporadaInvernoDesc: 'Geadas frequentes e possibilidade de neve — alta procura nessa época.',
    winterLodging: 'Hospedagens para o inverno',
    trilhasMirantes: 'Trilhas e Mirantes',
    trilhasMirantesDesc: 'Experiências ao ar livre para quem gosta de aventura e paisagens únicas.',
    exploreNearbyLodging: 'Explorar hospedagens próximas',
    routesTitle: 'Roteiros para viver Urubici',
    routesDescription: 'Planeje sua estadia com experiências organizadas e escolha a hospedagem ideal para cada perfil de viagem.',
    winterRoute: 'Roteiro de Inverno — 2 dias na serra',
    winterRouteDesc: 'Frio intenso, lareira, gastronomia e os principais atrativos em um final de semana perfeito.',
    seeWinterLodging: 'Ver hospedagens para o inverno',
    exploreFullRoute: 'Explorar roteiro completo',
    natureRoadRoute: 'Roteiro Natureza & Estrada',
    natureRoadRouteDesc: 'Serra do Corvo Branco, mirantes e trilhas para quem ama estrada, aventura e paisagens únicas.',
    lodgingForBikers: 'Hospedagens ideais para motociclistas',
    seeRouteMap: 'Ver mapa do trajeto',
    whereToStayTitle: 'Onde se hospedar para cada experiência',
    whereToStayDescription: 'Escolha a região ideal e encontre hospedagens que combinam com o seu estilo de viagem.',
    centroRegion: 'Centro Histórico',
    centroRegionDesc: 'Ideal para quem quer restaurantes, cafés e acesso fácil aos principais atrativos.',
    seeLodgingCentro: 'Ver hospedagens no Centro',
    morroRegion: 'Morro da Igreja & Altitude',
    morroRegionDesc: 'Perfeito para quem busca frio intenso, lareira e paisagens impressionantes.',
    seeFireplaceChalets: 'Ver chalés com lareira',
    serraRegion: 'Serra do Corvo Branco',
    serraRegionDesc: 'Roteiros de estrada, mirantes e hospedagens com estacionamento amplo.',
    seeBikerLodging: 'Ver hospedagens para motociclistas',
    finalCtaTitle: 'Escolha onde ficar enquanto vive Urubici',
    finalCtaDescription: 'Os atrativos impressionam. A hospedagem certa transforma a experiência.',
    seeAvailableLodging: 'Ver hospedagens disponíveis agora',
    exploreAdvancedFilters: 'Explorar filtros avançados',
    realTimeAvailability: 'Disponibilidade em tempo real',
    directReservation: 'Reserva direta',
    localSupport: 'Suporte local',
    cityPlaceholder: 'Cidade',
    seoTitle: 'O que fazer em Urubici SC - Pontos Turísticos',
    seoDescription: 'Descubra o que fazer em Urubici, SC. Morro da Igreja, Serra do Corvo Branco, cachoeiras, cânions e atrações da Serra Catarinense.',
    breadcrumbHome: 'Início',
    breadcrumbWhatToDo: 'O que fazer',
  },
  restaurantes: {
    heroTitle: 'Sabores que aquecem o frio de Urubici',
    heroDescription: 'Da gastronomia serrana aos cafés aconchegantes, descubra onde viver a experiência completa na serra.',
    seeNearbyLodging: 'Ver hospedagens próximas',
    exploreRestaurants: 'Explorar restaurantes',
    filterByType: 'Filtrar por tipo',
    filterAll: 'Todos',
    filterFineDining: 'Alta gastronomia',
    filterCafes: 'Cafés',
    filterSteakhouse: 'Churrascarias',
    filterItalian: 'Italiano',
    filterRegional: 'Regional',
    filterNearCenter: 'Perto do centro',
    recommendedTitle: 'Restaurantes recomendados em Urubici',
    recommendedDescription: 'Curadoria local para completar sua viagem — especialmente no inverno.',
    viewDetails: 'Ver detalhes',
    nearbyLodging: 'Hospedagens próximas →',
    highlySought: 'Muito procurado no inverno',
    gastroAccommodationTitle: 'Gastronomia e hospedagem caminham juntas',
    gastroAccommodationDesc: 'No inverno, os restaurantes mais procurados lotam cedo — e as melhores hospedagens próximas ao centro esgotam rápido. Garanta sua base em Urubici e viva a experiência com conforto.',
    bulletLessTravel: 'Menos deslocamento à noite',
    bulletMoreComfort: 'Mais conforto no frio',
    bulletBetterExperience: 'Melhor experiência nos atrativos',
    seeDowntownLodging: 'Ver hospedagens no centro',
    centroUrubici: 'Centro de Urubici',
    bestLocationGastro: 'A melhor localização para gastronomia',
    finalCtaTitle: 'Já escolheu onde jantar. Agora escolha onde ficar.',
    finalCtaSubtitle: 'Garanta sua hospedagem em Urubici com disponibilidade em tempo real e confirmação imediata.',
    seeAvailableNow: 'Ver hospedagens disponíveis agora',
    realTimeAvailability: 'Disponibilidade em tempo real',
    directLocalBooking: 'Reserva direta com estabelecimentos locais',
    whatsappSupport: 'Suporte humano via WhatsApp',
    seoTitle: 'Restaurantes em Urubici SC - Gastronomia da Serra',
    seoDescription: 'Descubra os melhores restaurantes em Urubici, SC. Alta gastronomia, cafés, churrascarias e culinária regional da serra catarinense.',
    breadcrumbHome: 'Início',
    breadcrumbRestaurants: 'Restaurantes',
  },
  restauranteDetalhes: {
    shareAriaLabel: 'Compartilhar',
    favoriteAriaLabel: 'Favoritar',
    previousImage: 'Imagem anterior',
    nextImage: 'Próxima imagem',
    idealFor: 'Ideal para',
    planYourNight: 'Planeje sua noite',
    schedule: 'Horário',
    priceRange: 'Faixa de preço',
    highlightsSection: 'Destaques',
    seeNearbyLodging: 'Ver hospedagens próximas',
    seeMoreRestaurants: 'Ver mais restaurantes',
    trustMicrocopy: 'Reserve a hospedagem e aproveite a serra com conforto.',
    aboutRestaurant: 'Sobre este restaurante',
    showMore: 'Mostrar mais',
    showLess: 'Mostrar menos',
    highlightsTitle: 'Destaques',
    searchLodgingRegion: 'Buscar hospedagem para esta região',
    exploreUrubici: 'Explorar Urubici',
    location: 'Localização',
    howToGetThere: 'Como chegar',
    easyAccess: 'Acesso fácil pela SC-110',
    nearCentro: 'Próximo ao Centro de Urubici',
    idealWalking: 'Ideal para ir a pé a partir de hospedagens no centro',
    tip: 'Dica',
    tipText: 'No inverno, priorize hospedagens próximas para evitar deslocamentos longos à noite.',
    seeAttractionsNearby: 'Ver atrativos próximos',
    customerReviews: 'Avaliações de clientes',
    verifiedReviews: 'avaliações verificadas',
    basedOnReal: 'Baseado em avaliações reais de visitantes.',
    viewAllReviews: 'Ver todas as avaliações',
    reviewDisclaimer: 'Conteúdo ilustrativo. As avaliações serão carregadas dinamicamente futuramente.',
    nearbyAccommodations: 'Hospedagens próximas',
    nearbyDesc: 'Fique perto do centro e aproveite melhor a experiência.',
    startingAt: 'A partir de',
    perNight: '/ noite',
    seeAllDowntown: 'Ver todas as hospedagens no centro',
    similarRestaurants: 'Restaurantes similares',
    similarRestaurantsDesc: 'Outras opções com o mesmo clima aconchegante para noites frias.',
    viewDetails: 'Ver detalhes',
    realTimeAvailability: 'Disponibilidade em tempo real',
    directReservation: 'Reserva direta',
    whatsappSupport: 'Suporte humano via WhatsApp',
    finalCtaTitle: 'Combine jantar e hospedagem com conforto',
    reviewPerfectNight: '"Noite perfeita no frio. Lareira, vinho e pratos incríveis."',
    reviewImpeccable: '"Ambiente aconchegante e atendimento impecável. Voltaremos!"',
    service: 'Atendimento',
    ambiance: 'Ambiente',
    flavor: 'Sabor',
    valueForMoney: 'Custo-benefício',
    winterTip: 'No inverno, garantir uma boa base no centro faz toda diferença para aproveitar Urubici.',
    exploreMore: 'Explorar mais restaurantes',
    seoTitle: 'Restaurante em Urubici - Detalhes e Avaliações',
  },
  experiencias: {
    seoTitle: 'Experiências em Urubici SC - Aventuras na Serra',
    seoDescription: 'Viva experiências únicas em Urubici, SC. Cânions, cachoeiras, cavalgadas, degustações e aventuras na Serra Catarinense.',
    heroLabel: 'Descubra a Serra',
    heroTitle: 'Experiências Inesquecíveis',
    heroDescription: 'De aventuras radicais a momentos de contemplação, encontre a atividade perfeita para sua estadia em Urubici.',
    trustGuides: 'Guia Certificados',
    trustGuidesSub: 'Profissionais locais experientes',
    trustInsurance: 'Seguro Aventura',
    trustInsuranceSub: 'Cobertura completa inclusa',
    trustFlexible: 'Reserva Flexível',
    trustFlexibleSub: 'Cancele com até 48h de antecedência',
    curatedTitle: 'Curadoria Premium',
    mainTitle: 'O Melhor de Urubici',
    mainDescription: 'Atividades selecionadas para todos os estilos de viajantes',
    btnDetails: 'Ver detalhes',
    ctaTitle: 'Pronto para sua próxima aventura?',
    ctaDescription: 'Reserve agora e garanta sua vaga nas experiências mais disputadas de Urubici. Confirmação instantânea direta com os operadores.',
    ctaSearchLodging: 'Buscar Hospedagem',
    ctaNeedHelp: 'Precisa de ajuda?',
    talkToCentral: 'Fale com nossa central de reservas',
    cards: [
      {
        id: 1,
        title: 'Passeio ao Cânion Espraiado',
        description: 'Uma das vistas mais impactantes da Serra Catarinense em um tour guiado exclusivo.',
        image: 'https://readdy.ai/api/search-image?query=stunning%20canyon%20view%20in%20brazilian%20mountains%20dramatic%20cliffs%20foggy%20valley%20morning%20light%20premium%20travel%20photography&width=800&height=600&seq=exp1',
        price: 'R$ 180',
        category: 'Aventura',
      },
      {
        id: 2,
        title: 'Degustação de Vinhos de Altitude',
        description: 'Visita às vinícolas premiadas de Urubici com harmonização de queijos locais.',
        image: 'https://readdy.ai/api/search-image?query=luxury%20winery%20tasting%20room%20view%20of%20vineyard%20at%20sunset%20wine%20glasses%20on%20table%20elegant%20atmosphere&width=800&height=600&seq=exp2',
        price: 'R$ 250',
        category: 'Gastronomia',
      },
      {
        id: 3,
        title: 'Cavalgada ao Nascer do Sol',
        description: 'Acompanhe o despertar da serra a cavalo pelos campos de altitude.',
        image: 'https://readdy.ai/api/search-image?query=horseback%20riding%20at%20sunrise%20in%20misty%20mountains%20silhouette%20outdoor%20adventure%20premium%20experience&width=800&height=600&seq=exp3',
        price: 'R$ 150',
        category: 'Natureza',
      },
      {
        id: 4,
        title: 'Expedição Cachoeira do Avencal',
        description: 'Acesso exclusivo e trilhas guiadas pela base da maior queda d\'água da região.',
        image: 'https://readdy.ai/api/search-image?query=massive%20waterfall%20in%20brazilian%20nature%20lush%20green%20forest%20pristine%20environment%20natural%20beauty&width=800&height=600&seq=exp4',
        price: 'R$ 120',
        category: 'Aventura',
      },
      {
        id: 5,
        title: 'Piquenique no Morro da Igreja',
        description: 'Cesta gourmet completa para apreciar o ponto mais alto do Sul do Brasil.',
        image: 'https://readdy.ai/api/search-image?query=picnic%20with%20stunning%20mountain%20view%20gourmet%20basket%20wine%20comfortable%20setup%20golden%20hour&width=800&height=600&seq=exp5',
        price: 'R$ 320',
        category: 'Romântico',
      },
      {
        id: 6,
        title: 'Tour Fotográfico Noturno',
        description: 'Capture as estrelas do céu mais límpido do Brasil com orientação profissional.',
        image: 'https://readdy.ai/api/search-image?query=milky%20way%20night%20sky%20over%20mountains%20long%20exposure%20photography%20stunning%20nature&width=800&height=600&seq=exp6',
        price: 'R$ 200',
        category: 'Cultura',
      },
    ],
    breadcrumbHome: 'Início',
    breadcrumbExperiences: 'Experiências',
  },
  eventos: {
    seoTitle: 'Eventos em Urubici SC - Calendário 2026',
    seoDescription: 'Calendário de eventos em Urubici, SC 2026. Festivais, encontros de motociclistas, inverno e celebrações culturais na Serra Catarinense.',
    heroTitle: 'Eventos em Urubici que movimentam a serra',
    heroDescription: 'Planeje sua viagem com antecedência e garanta a melhor hospedagem para cada temporada.',
    seeAvailableLodging: 'Ver hospedagens disponíveis',
    seeFullCalendar: 'Ver calendário completo',
    filterByType: 'Filtrar por tipo',
    filterAll: 'Todos',
    filterWinter: 'Inverno',
    filterMotorcycle: 'Motociclismo',
    filterCulture: 'Cultura',
    filterNature: 'Natureza',
    upcomingEvents: 'Próximos eventos em Urubici',
    upcomingEventsDesc: 'Planeje sua hospedagem com antecedência para as datas mais procuradas.',
    seeLodgingDates: 'Ver hospedagens nessas datas',
    realTimeDates: 'Disponibilidade em tempo real para as datas do evento.',
    impactTitle: 'Como os eventos impactam a hospedagem em Urubici',
    impactDescription: 'Datas especiais elevam a ocupação e esgotam as melhores opções mais rápido.',
    occupancyCard1: '+60% de ocupação no inverno',
    occupancyCard1Desc: 'Fins de semana frios costumam esgotar chalés e pousadas com lareira.',
    occupancyCard2: 'Pico de reservas 30 dias antes',
    occupancyCard2Desc: 'Encontros de motociclistas aumentam a demanda por hospedagens com estacionamento.',
    occupancyCard3: 'Geadas e feriados esgotam rápido',
    occupancyCard3Desc: 'Quando o frio aperta, a procura cresce em poucas horas.',
    seeLodgingTheseDates: 'Ver hospedagens para estas datas',
    exploreAdvancedFilters: 'Explorar filtros avançados',
    planTitle: 'Planeje sua viagem para os eventos',
    planDescription: 'Organize sua experiência em Urubici com antecedência.',
    planRestaurants: 'Restaurantes recomendados',
    planRestaurantsDesc: 'Descubra onde jantar durante os eventos.',
    seeRestaurants: 'Ver restaurantes',
    planRoute: 'Roteiro de 2 dias',
    planRouteDesc: 'Sugestão de roteiro para aproveitar a serra.',
    exploreRoute: 'Explorar roteiro',
    planHowToGet: 'Como chegar',
    planHowToGetDesc: 'Dicas de acesso e melhores rotas.',
    seeDirections: 'Ver orientações',
    planWinterGear: 'O que levar no inverno',
    planWinterGearDesc: 'Prepare-se para o frio intenso.',
    seeTips: 'Ver dicas',
    searchEventLodging: 'Buscar hospedagem para o evento',
    whyReserveTitle: 'Por que reservar hospedagem antes dos eventos?',
    whyReserve1: 'Alta ocupação',
    whyReserve1Desc: 'nas temporadas de inverno',
    whyReserve2: 'Encontro de motociclistas',
    whyReserve2Desc: 'com grande procura',
    whyReserve3: 'Eventos culturais e festivais',
    whyReserve3Desc: 'com vagas limitadas',
    searchEventLodgingCta: 'Buscar hospedagem para eventos',
    mainEventsTitle: 'Principais eventos e temporadas',
    mainEventsDesc: 'Descubra os melhores momentos para visitar Urubici e garanta sua hospedagem',
    winterSeason: 'Temporada de Inverno',
    winterSeasonDesc: 'Alta demanda por chalés e pousadas com lareira.',
    seeWinterLodging: 'Ver hospedagens para o inverno',
    motorcycleMeetup: 'Encontro de Motociclistas',
    motorcycleMeetupDesc: 'Point nacional com grande fluxo na serra.',
    lodgingForBikers: 'Hospedagens ideais para motociclistas',
    festivalsCulture: 'Festivais & Cultura',
    festivalsCultureDesc: 'Planeje sua estadia para eventos especiais.',
    searchEventAccommodation: 'Buscar hospedagem para eventos',
    notFoundEvent: 'Não encontrou o evento que procura? Veja todas as opções de hospedagem disponíveis.',
    seeAllLodging: 'Ver todas as hospedagens',
    finalCtaTitle: 'Garanta sua hospedagem para os próximos eventos',
    finalCtaDesc: 'Evite ficar sem opções nas datas mais procuradas. Reserve agora com disponibilidade em tempo real.',
    searchAvailableLodging: 'Buscar hospedagens disponíveis',
    trustFooter: 'Confirmação imediata • Sem taxas ocultas • Suporte local',
    breadcrumbHome: 'Início',
    breadcrumbEvents: 'Eventos',
    eventCulture: 'Cultura',
    eventNature: 'Natureza',
    eventWinter: 'Inverno',
    eventMotorcycle: 'Motociclismo',
    highDemand: 'Alta procura nas datas do evento',
    faqQuestion1: 'Qual a melhor época para visitar Urubici?',
    faqAnswer1: 'O inverno (junho-agosto) é ideal para quem busca frio e possibilidade de geada. O verão é perfeito para cachoeiras e trilhas. Cada estação tem seu charme especial.',
    faqQuestion2: 'Os eventos são gratuitos?',
    faqAnswer2: 'Alguns eventos são gratuitos, outros possuem ingresso. Recomendamos verificar a programação específica de cada evento e reservar hospedagem com antecedência.',
  },
  contato: {
    seoTitle: 'Contato - Reserve Connect Urubici',
    seoDescription: 'Entre em contato com a Central de Reservas do Reserve Connect Urubici. Atendimento via WhatsApp para dúvidas sobre hospedagens e eventos.',
    heroLabel: 'Atendimento',
    heroTitle: 'Fale com a Central do Reserve Connect',
    heroDescription: 'Dúvidas sobre hospedagens, eventos, grupos ou sua reserva? A gente ajuda.',
    whatsappButton: 'Falar no WhatsApp',
    sendMessage: 'Enviar mensagem',
    whatsappCardTitle: 'WhatsApp',
    whatsappCardDesc: 'Atendimento humano e ágil para suas dúvidas.',
    startChat: 'Iniciar conversa',
    emailCardTitle: 'E-mail',
    emailCardDesc: 'Ideal para solicitações complexas ou formais.',
    emailResponseTime: 'Retorno em até 24h',
    faqCardTitle: 'Perguntas Frequentes',
    faqCardDesc: 'As respostas que você precisa agora mesmo.',
    accessFaq: 'Acessar FAQ',
    newMessage: 'Nova mensagem',
    sending: 'Enviando...',
    formTitle: 'Envie uma mensagem',
    formName: 'Nome',
    formNamePlaceholder: 'Seu nome completo',
    formWhatsapp: 'WhatsApp',
    formEmail: 'E-mail',
    formEmailOptional: '(opcional)',
    formSubject: 'Assunto',
    formSubjectPlaceholder: 'Selecione um assunto',
    formSubjectReservation: 'Reserva',
    formSubjectLodging: 'Hospedagens',
    formSubjectEvents: 'Eventos',
    formSubjectGroups: 'Grupos e Agências',
    formSubjectOther: 'Outro',
    formMessage: 'Mensagem',
    formMessagePlaceholder: 'Como podemos ajudar?',
    formCharLimit: 'Limites de caracteres: 500',
    formSubmit: 'Enviar mensagem',
    formReturnTime: 'Retornamos em até 24h.',
    formWhatsappSupport: 'Atendimento humano via WhatsApp',
    finalCtaTitle: 'Planeje sua viagem com tranquilidade.',
    seeAvailableLodging: 'Ver hospedagens disponíveis',
    realTimeAvailability: 'Disponibilidade em tempo real',
    directReservation: 'Reserva direta',
    localSupport: 'Suporte local',
    breadcrumbHome: 'Início',
    breadcrumbContact: 'Contato',
  },
  sobre: {
    seoTitle: 'Sobre Urubici SC - Guia Completo da Cidade',
    seoDescription: 'Conheça Urubici, a pérola da Serra Catarinense. História, clima, melhor época para visitar e tudo sobre esse destino único no sul do Brasil.',
    heroTitle: 'Urubici by Reserve Connect',
    heroDescription: 'Uma plataforma criada para conectar viajantes às melhores experiências e hospedagens da serra.',
    seeAvailableLodging: 'Ver hospedagens disponíveis',
    exploreCity: 'Explorar a cidade',
    positioningTitle: 'Mais do que um site. Uma infraestrutura de reservas local.',
    positioningDescription: 'O Reserve Connect nasce com um propósito claro: organizar a oferta de hospedagens, restaurantes e experiências de Urubici em uma plataforma moderna, segura e focada na conversão.',
    techTitle: 'Tecnologia própria',
    techDesc: 'Disponibilidade em tempo real e integração com a rede local.',
    curationTitle: 'Curadoria regional',
    curationDesc: 'Estabelecimentos selecionados e verificados.',
    supportTitle: 'Suporte humano',
    supportDesc: 'Atendimento via WhatsApp e central de reservas.',
    howItWorks: 'Como funciona',
    howItWorksDesc: 'Uma jornada simples, direta e segura.',
    step1Title: 'Escolha sua experiência',
    step1Desc: 'Hospedagens, restaurantes, eventos ou roteiros.',
    step2Title: 'Compare e planeje',
    step2Desc: 'Filtros inteligentes e informações claras.',
    step3Title: 'Reserve com confiança',
    step3Desc: 'Disponibilidade em tempo real e confirmação imediata.',
    step4Title: 'Viva Urubici',
    step4Desc: 'Com suporte local e experiências selecionadas.',
    searchLodgingNow: 'Buscar hospedagem agora',
    connectedTitle: 'Conectado à rede local de Urubici',
    connectedDesc: 'O Reserve Connect integra estabelecimentos locais, central de reservas e tecnologia própria para organizar a oferta turística da cidade.',
    securePlatform: 'Plataforma segura',
    protectedPayment: 'Pagamento protegido',
    humanSupport: 'Atendimento humano',
    talkToCentral: 'Falar com a central',
    commitmentTitle: 'Compromisso com a cidade',
    commitment1: 'Parceria com hospedagens locais',
    commitment2: 'Organização da oferta turística',
    commitment3: 'Foco em conversão e sustentabilidade regional',
    finalCtaTitle: 'Planeje sua próxima viagem para Urubici com confiança.',
    finalCtaDesc: 'Tecnologia, curadoria local e suporte humano para uma experiência completa.',
    realTimeAvailability: 'Disponibilidade em tempo real',
    whatsappSupport: 'Suporte via WhatsApp',
    breadcrumbHome: 'Início',
    breadcrumbAbout: 'Sobre Urubici',
  },
  grupos: {
    heroTitle: 'Vindo para Urubici com grupo ou agência?',
    heroDescription: 'Condições especiais para excursões, motoclubes, eventos corporativos e viagens organizadas.',
    requestProposal: 'Solicitar proposta para grupo',
    talkToWhatsapp: 'Falar com consultor no WhatsApp',
    sectionTitle: 'Para quem organizamos hospedagens',
    sectionDescription: 'Estruturamos a melhor solução para cada perfil de grupo.',
    motoclubes: 'Motoclubes',
    motoclubesDesc: 'Estacionamento amplo, fácil acesso e hospedagens preparadas para grupos de motociclistas.',
    motoclubesCta: 'Solicitar proposta para motoclube',
    excursions: 'Excursões',
    excursionsDesc: 'Organização simplificada para grupos de turismo e viagens coletivas.',
    excursionsCta: 'Solicitar proposta para excursão',
    corporate: 'Corporativo',
    corporateDesc: 'Eventos empresariais, treinamentos e encontros executivos na serra.',
    corporateCta: 'Solicitar proposta corporativa',
    churches: 'Igrejas e retiros',
    churchesDesc: 'Retiros espirituais e encontros com estrutura adequada para grupos.',
    churchesCta: 'Solicitar proposta para retiro',
    whyTitle: 'Por que organizar com o Reserve Connect?',
    whyDescription: 'Centralizamos a negociação e estruturamos a melhor hospedagem para o seu grupo em Urubici.',
    benefit1: 'Negociação centralizada com a rede local',
    benefit2: 'Curadoria de hospedagens ideais para grupos',
    benefit3: 'Atendimento humano via WhatsApp',
    benefit4: 'Flexibilidade para datas, perfis e orçamento',
    benefit5: 'Suporte antes, durante e após a viagem',
    highlight1: 'Resposta em até 24h',
    highlight2: 'Condições especiais para grupos',
    highlight3: 'Suporte local',
    formTitle: 'Solicite uma proposta para o seu grupo',
    formDescription: 'Conte o perfil do grupo e as datas. Retornamos com as melhores opções de hospedagem em Urubici.',
    formSuccessTitle: 'Recebemos seu pedido!',
    formSuccessMessage: 'Em breve nossa equipe retorna no WhatsApp.',
    formSendAnother: 'Enviar outra solicitação',
    formError: 'Ocorreu um erro ao enviar. Por favor, tente novamente.',
    formName: 'Nome completo',
    formCompany: 'Empresa/Grupo',
    formCompanyPlaceholder: 'Nome da empresa ou grupo',
    formGroupType: 'Tipo de grupo',
    formGroupTypePlaceholder: 'Selecione o tipo',
    formGroupTypeMotoclube: 'Motoclube',
    formGroupTypeExcursao: 'Excursão',
    formGroupTypeCorporativo: 'Corporativo',
    formGroupTypeIgreja: 'Igreja/Retiro',
    formGroupTypeOther: 'Outro',
    formQuantity: 'Quantidade de pessoas',
    formQuantityPlaceholder: 'Ex: 20',
    formStartDate: 'Data inicial',
    formEndDate: 'Data final',
    formWhatsapp: 'WhatsApp',
    formEmail: 'E-mail',
    formEmailPlaceholder: 'seu@email.com',
    formMessage: 'Mensagem',
    formMessagePlaceholder: 'Conte mais sobre o seu grupo, necessidades especiais ou dúvidas...',
    formCharLimit: 'caracteres',
    formSending: 'Enviando...',
    formSubmit: 'Receber proposta personalizada',
    formMicrocopy: 'Retornamos em até 24h. Atendimento humano via WhatsApp.',
  },
  legal: {
    lastUpdated: 'Última atualização: Março de 2026.',
    terms: {
      institutional: 'Institucional',
      heroTitle: 'Termos de Uso',
      heroDescription: 'Regras e condições para utilização da plataforma Reserve Connect.',
      seeAvailableLodging: 'Ver hospedagens disponíveis',
      talkToCentral: 'Falar com a Central',
      section1Title: '1. Sobre a Plataforma',
      section1Body: 'O Reserve Connect é uma plataforma privada de intermediação de hospedagens e experiências turísticas em Urubici, conectando viajantes a estabelecimentos parceiros locais.',
      section2Title: '2. Intermediação',
      section2Body: 'A plataforma atua como intermediadora entre viajantes e estabelecimentos. As reservas são realizadas diretamente com os parceiros cadastrados.',
      section3Title: '3. Disponibilidade e Informações',
      section3Body: 'As informações de disponibilidade, preços e condições são fornecidas pelos estabelecimentos parceiros e podem sofrer alterações sem aviso prévio.',
      section4Title: '4. Cancelamentos',
      section4Body: 'As políticas de cancelamento seguem as regras definidas por cada estabelecimento parceiro, devendo o usuário consultá-las antes da confirmação da reserva.',
      section5Title: '5. Responsabilidades do Usuário',
      section5Body: 'O usuário se compromete a fornecer informações corretas e atualizadas ao realizar solicitações ou reservas na plataforma.',
      section6Title: '6. Limitação de Responsabilidade',
      section6Body: 'O Reserve Connect não se responsabiliza por eventos decorrentes da prestação de serviços pelos parceiros, atuando exclusivamente como facilitador da conexão.',
      section7Title: '7. Alterações nos Termos',
      section7Body: 'Os presentes Termos de Uso podem ser atualizados periodicamente para refletir melhorias na plataforma ou adequações legais.',
      section8Title: '8. Contato',
      section8Body: 'Para esclarecimentos adicionais, entre em contato com nossa Central de Reservas.',
      finalCtaTitle: 'Planeje sua próxima viagem para Urubici com confiança.',
      finalCtaDesc: 'Tecnologia, curadoria local e suporte humano para uma experiência completa.',
      talkToCentralCta: 'Falar com a central',
      realTimeAvailability: 'Disponibilidade em tempo real',
      directReservation: 'Reserva direta',
      whatsappSupport: 'Suporte via WhatsApp',
    },
    privacy: {
      heroLabel: 'Privacidade',
      heroTitle: 'Política de Privacidade',
      heroDescription: 'Como coletamos, usamos e protegemos seus dados ao utilizar o Reserve Connect.',
      seeAvailableLodging: 'Ver hospedagens disponíveis',
      talkToCentral: 'Falar com a Central',
      section1Title: '1. Objetivo desta Política',
      section1Body: 'Esta Política de Privacidade descreve como o Reserve Connect coleta e utiliza informações para viabilizar o funcionamento da plataforma e melhorar a experiência do usuário.',
      section2Title: '2. Dados que Podemos Coletar',
      section2Body: 'Podemos coletar dados fornecidos por você (como nome, e-mail e WhatsApp em formulários), além de dados técnicos de navegação (como páginas acessadas e tipo de dispositivo) para fins de segurança e melhoria da plataforma.',
      section3Title: '3. Uso das Informações',
      section3Body: 'Utilizamos os dados para: (a) responder solicitações e propostas, (b) melhorar a navegação e performance, (c) prevenir fraudes e garantir segurança, e (d) viabilizar contato com a Central quando solicitado.',
      section4Title: '4. Compartilhamento com Parceiros',
      section4Body: 'Quando necessário para atendimento ou solicitação de proposta, informações podem ser compartilhadas com estabelecimentos parceiros locais, estritamente para viabilizar o serviço solicitado.',
      section5Title: '5. Cookies e Tecnologias Semelhantes',
      section5Body: 'O Reserve Connect pode utilizar cookies para lembrar preferências e analisar o uso do site. Você pode gerenciar cookies pelo seu navegador.',
      section6Title: '6. Segurança',
      section6Body: 'Adotamos medidas técnicas e organizacionais para proteger dados contra acesso não autorizado, alteração ou divulgação.',
      section7Title: '7. Seus Direitos',
      section7Body: 'Você pode solicitar correção, atualização ou remoção de dados fornecidos por meio do nosso canal de atendimento.',
      section8Title: '8. Retenção',
      section8Body: 'Manteremos os dados apenas pelo tempo necessário para cumprir as finalidades descritas nesta política ou obrigações legais.',
      section9Title: '9. Contato',
      section9Body: 'Para solicitações relacionadas a privacidade, entre em contato com a Central de Reservas.',
      finalCtaTitle: 'Privacidade e transparência em cada conexão.',
      finalCtaDesc: 'Tecnologia, curadoria local e suporte humano para uma experiência completa e segura.',
      talkToCentralCta: 'Falar com a central',
      realTimeAvailability: 'Disponibilidade em tempo real',
      directReservation: 'Reserva direta',
      whatsappSupport: 'Suporte via WhatsApp',
    },
    cookies: {
      institutional: 'Institucional',
      heroTitle: 'Política de Cookies',
      heroDescription: 'Entenda como usamos cookies para melhorar sua experiência e tornar a navegação mais segura.',
      seeAvailableLodging: 'Ver hospedagens disponíveis',
      talkToCentral: 'Falar com a Central',
      section1Title: '1. O que são cookies',
      section1Body: 'Cookies são pequenos arquivos de texto enviados e armazenados no seu computador ou dispositivo móvel através do seu navegador. Eles servem para que o site "lembre" de suas ações e preferências ao longo do tempo, facilitando a navegação e personalizando sua experiência.',
      section2Title: '2. Por que usamos cookies',
      section2Body: 'Utilizamos cookies para diversas finalidades essenciais e analíticas, incluindo:',
      section2Item1Title: 'Funcionamento e desempenho:',
      section2Item1Desc: 'Para garantir que o site carregue corretamente e as funcionalidades básicas operem sem erros.',
      section2Item2Title: 'Preferências de navegação:',
      section2Item2Desc: 'Para lembrar suas escolhas, como idioma e filtros de busca, evitando que você precise configurá-los novamente.',
      section2Item3Title: 'Métricas e melhoria contínua:',
      section2Item3Desc: 'Para entender como os usuários interagem com a plataforma, quais páginas são mais visitadas e onde podemos evoluir.',
      section3Title: '3. Tipos de cookies',
      section3EssentialsTitle: 'Cookies Essenciais',
      section3EssentialsDesc: 'Indispensáveis para o funcionamento do site. Sem eles, serviços básicos de reserva e segurança não podem ser fornecidos.',
      section3PerformanceTitle: 'Cookies de Desempenho e Analíticos',
      section3PerformanceDesc: 'Coletam informações anônimas sobre como o site é usado. Nos ajudam a corrigir falhas e melhorar a velocidade de navegação.',
      section3FunctionalTitle: 'Cookies Funcionais',
      section3FunctionalDesc: 'Permitem funcionalidades avançadas e personalização, retendo escolhas feitas pelo usuário durante a sessão.',
      section3MarketingTitle: 'Cookies de Marketing',
      section3MarketingDesc: 'Utilizados para exibir anúncios relevantes ao perfil do usuário ou limitar a frequência de exibição de uma propaganda.',
      section4Title: '4. Como gerenciar cookies',
      section4Body: 'Você pode gerenciar ou desabilitar cookies diretamente nas configurações do seu navegador (Chrome, Safari, Firefox, Edge, etc.). No entanto, observe que bloquear cookies essenciais pode impedir o funcionamento correto de algumas partes do Reserve Connect, como o processo de reserva.',
      section5Title: '5. Atualizações desta política',
      section5Body: 'Esta política pode ser atualizada periodicamente para refletir mudanças em nossas práticas ou por razões operacionais, legais ou regulamentares. Recomendamos a consulta regular desta página.',
      finalCtaTitle: 'Transparência e segurança em cada etapa.',
      finalCtaDesc: 'Tecnologia, curadoria local e suporte humano para uma experiência completa e segura.',
      talkToCentralCta: 'Falar com a central',
      realTimeAvailability: 'Disponibilidade em tempo real',
      directReservation: 'Reserva direta',
      whatsappSupport: 'Suporte via WhatsApp',
    },
    cancellation: {
      heroLabel: 'Políticas',
      heroTitle: 'Cancelamento e Reembolso',
      heroDescription: 'Entenda as regras e procedimentos para cancelamentos e solicitações de reembolso.',
      seeAvailableLodging: 'Ver hospedagens disponíveis',
      talkToCentral: 'Falar com a Central',
      section1Title: '1. Regras Gerais',
      section1Body: 'O Reserve Connect atua como intermediário entre o viajante e os estabelecimentos parceiros. As políticas de cancelamento e reembolso variam de acordo com cada parceiro e devem ser consultadas no momento da reserva.',
      section2Title: '2. Prazos para Cancelamento',
      section2Body: 'Cada estabelecimento define seus próprios prazos de cancelamento sem multa. Geralmente, cancelamentos realizados com grande antecedência permitem o reembolso total ou parcial, conforme a regra da tarifa escolhida.',
      section3Title: '3. Procedimento de Solicitação',
      section3Body: 'Para solicitar um cancelamento, o usuário deve entrar em contato diretamente com a nossa Central de Reservas via WhatsApp ou e-mail, informando o número da reserva e o motivo da solicitação.',
      section4Title: '4. Processamento de Reembolsos',
      section4Body: 'Uma vez aprovado o reembolso pelo estabelecimento parceiro, o processamento será realizado através do mesmo método de pagamento utilizado na reserva. O prazo para o crédito aparecer na fatura depende da operadora do cartão ou do banco.',
      section5Title: '5. No-Show (Não Comparecimento)',
      section5Body: 'O não comparecimento na data do check-in sem aviso prévio nos prazos estabelecidos será considerado "no-show" e implicará na perda do valor pago, conforme a política específica do parceiro.',
      section6Title: '6. Casos Fortuitos ou Força Maior',
      section6Body: 'Em situações excepcionais que impeçam a prestação do serviço por parte do parceiro ou o deslocamento do viajante, as solicitações serão analisadas individualmente buscando a melhor solução para ambas as partes.',
      finalCtaTitle: 'Segurança e suporte em cada reserva.',
      finalCtaDesc: 'Tecnologia, curadoria local e suporte humano para uma experiência completa e sem sobressaltos.',
      talkToCentralCta: 'Falar com a central',
      realTimeAvailability: 'Disponibilidade em tempo real',
      directReservation: 'Reserva direta',
      whatsappSupport: 'Suporte via WhatsApp',
    },
  },
  tripPlanner: {
    pageTitle: 'Planeje sua Viagem',
    pageDescription: 'Monte seu roteiro ideal com hospedagens, restaurantes, experiências e eventos na Serra Catarinense.',
    title: 'Planeje sua Viagem',
    subtitle: 'Conte-nos suas datas e interesses para montarmos o roteiro ideal para você.',
    stepDates: 'Quando você vai?',
    stepInterests: 'O que te interessa?',
    interestsHint: 'Selecione os temas que mais combinam com sua viagem.',
    continue: 'Continuar',
    planMyTrip: 'Planejar minha viagem',
    planning: 'Planejando...',
    planError: 'Não foi possível gerar o roteiro. Tente novamente.',
    datesRequired: 'Selecione as datas de check-in e check-out.',
    yourItinerary: 'Seu Roteiro',
    day: 'Dia',
    morning: 'Manhã',
    afternoon: 'Tarde',
    evening: 'Noite',
    relaxDay: 'Dia livre para explorar no seu ritmo.',
    whereToStay: 'Onde ficar',
    noLodging: 'Nenhuma hospedagem encontrada para estas datas.',
    perNight: 'noite',
    seeAllLodging: 'Ver todas as hospedagens',
    eventsNearby: 'Eventos na região',
    seeAllEvents: 'Ver todos os eventos',
    saveYourPlan: 'Salvar roteiro',
    saveHint: 'Salve seu roteiro para acessar depois e compartilhar.',
    savePlan: 'Salvar roteiro',
    saving: 'Salvando...',
    planSaved: 'Roteiro salvo!',
    planSavedDesc: 'Seu roteiro foi salvo. Use o link abaixo para compartilhar ou acessar depois.',
    shareLink: 'Link do roteiro',
    copied: 'Copiado!',
    backToResults: 'Voltar ao roteiro',
    planAnotherTrip: 'Planejar outra viagem',
    newSearch: 'Nova busca',
  },
};
export default pages;
